// extracted by mini-css-extract-plugin
export default {"year":"NextPreviousNavButton_year__zOUU6"};